import SelectBox from "components/Common/SelectBox"
import React, { useEffect, useState } from "react"
import { Col, Input, Label, Row, Table } from "reactstrap"

export default function Specifications(props) {
  const { config } = props

  const { pantsSpecifications, setPantsSpecifications } = config
  const [pantsSpecs, setPantsSpecs] = useState([])

  useEffect(() => {
    if (!pantsSpecs.length) return loadSpecs()
  }, [props])

  const loadSpecs = () => {
    if (config && config.orderSheets) {
      const specs = config?.orderSheets?.pants?.specifications
        ?.filter(item => item.answer)
        .map(item => ({
          value: item.labels[0].sequence,
          label: item.labels[0].label,
        }))
      setPantsSpecs(specs)
    }
  }

  const onRadioSelect = (e, v, i, l) => {
    const answer = { sequence: parseInt(e.target.value), answer: l }

    const specs = {
      formId: v.formId,
      sequence: v.sequence,
      answers: [answer],
    }
    // return config.onChangePantsSpecifications(specs, i)
    config.handlePantsInput(specs, "specifications", i)
  }

  const onCheckboxChecked = (e, v, i) => {
    const answers = []
    const grandParent = e.target.parentNode.parentNode
    const checkBoxes = grandParent.querySelectorAll(`[name="${e.target.name}"]`)

    checkBoxes.forEach(checkBox => {
      if (checkBox.checked) {
        const { answer } = checkBox.dataset
        answers.push({
          sequence: parseInt(checkBox.value),
          answer: answer,
        })
      }
    })

    const spec = {
      formId: v.formId,
      sequence: v.sequence,
      answers: answers,
    }
    // console.log(spec)
    // return config.onChangePantsSpecifications(spec, i)
    config.handlePantsInput(spec, "specifications", i)
  }

  const onTextInputChange = (e, v, i) => {
    const answer = {
      sequence: parseInt(e.target.dataset.sequence),
      answer: e.target.value,
    }
    const spec = {
      formId: v.formId,
      sequence: v.sequence,
      answers: [answer],
    }
    // return config.onChangePantsSpecifications(spec, i)
    config.handlePantsInput(spec, "specifications", i)
  }

  const onDropdownSelect = (e, v, i) => {
    const answer = { sequence: e.value, answer: e.label }
    const stateSpec = [...pantsSpecifications]
    const spec = {
      formId: v.formId,
      sequence: v.sequence,
      answers: [answer],
    }
    stateSpec[i] = {
      label: spec.answers[0].answer,
      value: spec.answers[0].sequence,
    }

    setPantsSpecifications(stateSpec)
    config.handlePantsInput(spec, "specifications", i)
  }

  return (
    <Table bordered>
      <tbody>
        {config.orderSheets?.pants?.specifications.length
          ? config.orderSheets.pants.specifications.map((v, i) =>
              v.format === null ? (
                <tr style={{ height: 54 }} key={i}>
                  <td></td>
                </tr>
              ) : (
                <tr key={i}>
                  <td style={{ maxWidth: "max-content" }}>
                    <p className="mb-0">{v?.item || "-"}</p>
                  </td>
                  <td>
                    <Row className="g-3">
                      {v.format === "ラジオボタン" ? ( // radio
                        <div className="d-flex gap-4">
                          {v.labels.map(l => {
                            return (
                              <div key={l.sequence} className="d-flex">
                                <Input
                                  name={`${v.formId}${i}`}
                                  id={`spec${v.formId}${i}${l.sequence}`}
                                  className="me-2"
                                  type="radio"
                                  onChange={e =>
                                    onRadioSelect(e, v, i, l.label)
                                  }
                                  value={l.sequence}
                                  defaultChecked={false}
                                />
                                <Label
                                  htmlFor={`spec${v.formId}${i}${l.sequence}`}
                                >
                                  {l.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      ) : v.format === "プルダウン" ? ( // select
                        <div style={{ width: "100%" }}>
                          <SelectBox
                            options={v.labels.map(l => ({
                              label: l.label,
                              value: l.sequence,
                            }))}
                            onChange={e => onDropdownSelect(e, v, i)}
                            value={pantsSpecifications[i]}
                          />
                        </div>
                      ) : v.format === "チェックボックス" ? ( // checkbox
                        <div className="d-flex gap-2">
                          {v.labels.map(l => {
                            return (
                              <div className="d-flex" key={l.sequence}>
                                <Input
                                  name={`${v.formId}${i}`}
                                  id={`spec${v.formId}${i}${l.sequence}`}
                                  className="me-2"
                                  type="checkbox"
                                  value={l.sequence}
                                  onChange={e => onCheckboxChecked(e, v, i)}
                                  data-answer={l.label}
                                  defaultChecked={false}
                                />
                                <Label
                                  htmlFor={`spec${v.formId}${i}${l.sequence}`}
                                >
                                  {l.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      ) : (
                        // text input
                        <div style={{ width: "100%" }}>
                          <Input
                            className="me-2"
                            type="text"
                            onChange={e => onTextInputChange(e, v, i)}
                            data-sequence={1}
                            defaultValue={
                              config?.payload?.pants?.specifications[i]
                                ?.answers[0]?.answer
                            }
                          />
                        </div>
                      )}
                    </Row>
                  </td>
                </tr>
              )
            )
          : null}
      </tbody>
    </Table>
  )
}
